import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const ForeignDonationStatus = ({ open, onClose, status, message }) => {
  const isMobile = window.innerWidth <= 992;

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="foreign-donation-status-title"
      aria-describedby="foreign-donation-status-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? 300 : 800,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
        }}
      >
        {/* <img
          src={thankyou}
          alt="Status"
          style={{
            width: isMobile ? "150px" : "200px",
            height: "auto",
            marginBottom: "20px",
          }}
        /> */}
          <Typography 
          id="foreign-donation-status-title" 
          variant="h4" 
          component="h2"
          sx={{
            fontWeight: "bold",
            color: status === "success" ? "#00345B" : "#d32f2f",
            marginBottom: "16px",
            fontSize: isMobile ? "1.5rem" : "2rem",
          }}
        >
          {status === "success" ? "Thank you for your generous intention to support our mission" : "Email Failed to Send"}
        </Typography>
        
        {status === "success" ? (
          <Box sx={{ textAlign: "left", maxWidth: "100%", margin: "0 auto" }}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: "bold", 
                color: "#00345B", 
                marginBottom: "16px",
                textAlign: "center"
              }}
            >
              Primary SBI FCRA Account
            </Typography>
            
            <Box sx={{ 
              backgroundColor: "#f8f9fa", 
              padding: "20px", 
              borderRadius: "8px", 
              marginBottom: "20px",
              border: "1px solid #dee2e6"
            }}>
              <Box sx={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "8px", alignItems: "center" }}>
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>Account Name:</Typography>
                <Typography sx={{ color: "#212529" }}>Sood Charity Foundation</Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>Bank:</Typography>
                <Typography sx={{ color: "#212529" }}>State Bank of India (FCRA Cell)</Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>Account Number:</Typography>
                <Typography sx={{ color: "#212529", fontFamily: "monospace" }}>40176832768</Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>IFSC Code:</Typography>
                <Typography sx={{ color: "#212529", fontFamily: "monospace" }}>SBIN0000691</Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>SWIFT Code:</Typography>
                <Typography sx={{ color: "#212529", fontFamily: "monospace" }}>SBININBB104</Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>Address:</Typography>
                <Typography sx={{ color: "#212529" }}>
                  FCRA Cell, 4th Floor, State Bank of India,<br />
                  New Delhi Main Branch, 11 Sansad Marg,<br />
                  New Delhi – 110001
                </Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>Branch Code:</Typography>
                <Typography sx={{ color: "#212529", fontFamily: "monospace" }}>00691</Typography>
                
                <Typography sx={{ fontWeight: "600", color: "#495057" }}>Sort Code:</Typography>
                <Typography sx={{ color: "#212529", fontFamily: "monospace" }}>60-01-59</Typography>
              </Box>
            </Box>
              <Typography 
              sx={{ 
                fontSize: "14px",
                color: "#6c757d",
                fontStyle: "italic",
                textAlign: "center",
                marginBottom: "20px"
              }}
            >
              <strong>Note:</strong> Detailed bank information has been mailed by donation@soodcharityfoundation.org.
            </Typography>
          </Box>
        ) : (
          <Typography 
            id="foreign-donation-status-description" 
            sx={{ 
              mt: 2, 
              mb: 3,
              fontSize: "16px",
              color: "#666",
              lineHeight: 1.6
            }}
          >
            {message}
          </Typography>
        )}
        
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "#00345B",
            color: "white",
            borderRadius: "25px",
            padding: "12px 30px",
            fontSize: "16px",
            fontWeight: "600",
            "&:hover": {
              backgroundColor: "#002847",
            },
          }}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default ForeignDonationStatus;
